// Styles
import Tabs from "components/Common/Tabs/Tabs";
import AlertsTab from "components/Screens/DailyRecs/DailyFlowsCheck/AlertsTab/AlertsTab";
import ChangeLogTab from "components/Screens/DailyRecs/DailyFlowsCheck/ChangeLogTab/ChangeLogTab";
import ReportsTab from "components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import DailyFlowsCheckContainer from "./DailyFlowsCheck.styles";

interface DailyFlowsCheckProps {}

const checkName = "daily_flows";

const DailyFlowsCheck = ({}: DailyFlowsCheckProps) => {
    return (
        <DailyFlowsCheckContainer>
            <p className={"sectionTitle"}>DAILY FLOWS</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ReportsTab reportId="273a79d5-e423-4706-a5f0-9a608d07933a" workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128" />,
                    },
                    {
                        value: "alerts",
                        title: "ALERTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <AlertsTab checkName={checkName} />,
                    },
                    {
                        value: "change_log",
                        title: "CHANGE LOG",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ChangeLogTab checkName={checkName} />,
                    },
                ]}
            />
        </DailyFlowsCheckContainer>
    );
};

export default DailyFlowsCheck;
